import React from "react";
// logo
import logo from "../../assets/logo_150.png";
// mui
import { Avatar, Tooltip } from "@mui/material";
// package json
const NavbarLogo = () => {
    return (
        <Tooltip title={process.env.REACT_APP_VERSION}>
            <Avatar
                src={logo}
                variant="square"
                sx={{
                    width: "150px",
                    height: "150px",
                    // background: "white",
                    "& .MuiAvatar-img": {
                        // width: "100px",
                        // height: "100px",
                        objectFit: "contain",
                    },
                }}
            />
        </Tooltip>
    );
};

export default NavbarLogo;
